export default __webpack_public_path__ + "static/oedumapie_grafika-66df6af92a28b5de48088d4022cd3567.svg";